/**
 * A global namespace for `document.body`.
 */
const { body: documentBody } = document;
export default documentBody;
